import { useCallback, useEffect, useState, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  useSelectedFilterActionsContext,
  useSelectedFilterContext,
  useItemSelectedFilterActionsContext,
  useItemSelectedFilterContext,
} from "../../../Context/GridEquipListContext";

import { useGlobalSpinnerActionsContext } from "./../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "./../../../Context/LanguageContext";
import {
  useAMGSelectedContext,
  useSearchQueryContext,
  usePageSizeContext,
  usePageSizeActionContext,
  useCurrentPageContext,
  useCurrentPageActionContext,
  useSearchQueryActionContext,
  useMainGridSortActionContext,
  useMainGridSortContext,
  useSelectedFunContext,
} from "./../../../Context/GlobalContext";

import Paginator from "./../../Pagging/Paginator";

import equipmentGroupConstants from "./../../../Constants/EquipmentGroupConstants";
import equipmentGroupActions from "./../../../Actions/EquipmentGroupActions";
import equipmentGroupStore from "./../../../Stores/EquipmentGroupStore";

import SearchBox_new from "../../FilterOptions/SearchComponent/SearchBox_new";
import MessageBox from "../../MessageBox/MessageBox";
import _ from "lodash";
import { useSelectedConfigActionContext } from "./../../../Context/GlobalContext";
import { equipmentClick } from "../Equipment Selected/EquipmentClick";
import GridTable from "../../ReusableComponent/GridTable/GridTable";
import HeaderBar from "../../ReusableComponent/Header/HeaderBar";
import GridColumn_SettingActions from "../../../Actions/GridColumn_SettingActions";
import GridColumnSettingControl from "../../FilterOptions/GridColumnSettingControl";
import gridColSettingStore from "../../../Stores/GridColumn_SettingStores";
import GridColSettingConstants from "../../../Constants/GridColumn_SettingConstants";
import { toast } from "react-toastify";

const UeberfaelligeAuftraege = ({ fonctionsname, fonctionid }) => {
  //--context
  const selectedFilter = useSelectedFilterContext();
  const updateSelectedFilter = useSelectedFilterActionsContext();

  const itemSelectedFilter = useItemSelectedFilterContext();
  const updateListSelectedFilter = useItemSelectedFilterActionsContext();

  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const selectedAnlageG = useAMGSelectedContext();

  const searchQuery = useSearchQueryContext();
  const UpdateSearchQuery = useSearchQueryActionContext();

  const pageSize = usePageSizeContext();
  const currentPage = useCurrentPageContext();

  const UpdateCurrentPage = useCurrentPageActionContext();
  const UpdatePageSize = usePageSizeActionContext();

  const sortBy = useMainGridSortContext();
  const UpdateSortBy = useMainGridSortActionContext();

  const selectedFuncId = useSelectedFunContext();
  const updateSelectedConfig = useSelectedConfigActionContext();

  //----variable deklaration
  const [data, setData] = useState(null);
  const [exportOption, setExportOption] = useState(null);

  const isMountedRef = useRef(null);
  const AMGRef = useRef();

  const [renderMe, setRenderMe] = useState(null);
  const [tbody, setTBody] = useState(null);

  const [responseStatus, setResponseStatus] = useState(null);
  const [renderResponseMsg, setRenderResponseMsg] = useState(null);

  const [clearfilter, setClearFilter] = useState(false);
  const [exportData, setExportData] = useState(null);
  const [refresh, setRefresh] = useState(0);

  const [columns, setColumns] = useState(null);

  const [openSearchBox, setOpenSearchBox] = useState(false);

  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [messageBoxText, setMessageBoxText] = useState({});
  const [msgButtons, setMsgButtons] = useState([]);
  const [disabledSavedFilter, setDisabledSavedFilter] = useState(false);
  const [tableData, setTableData] = useState({
    data: [],
    headerName: [],
    headers: {},
    filterName: [],
  });
  const [gridAction, setGridAction] = useState({
    actionName: [],
    functionHandler: "",
  });
  const [paginatorData, setpaginatorData] = useState({
    pageCount: "",
    pageSize: "",
    firstRowOnPage: "",
    lastRowOnPage: "",
    rowCount: "",
    rowLength: 0,
  });
  const [_orginalResponse, set_orginalResponse] = useState([]);
  const [renderTable, setRenderTable] = useState("");
  const headerBarControl = {
    clientFilter: true,
    filter: true,
    actionList: true,
    isPaginator: true,
  };
  const [dropValueToHeader, setDropValueToHeader] = useState([]);
  const [tablefunctions, setTablefunctions] = useState(null);
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [showSearchDialog, setShowSearchDialog] = useState(false);
  const currentPageRef = useRef();
  currentPageRef.current = currentPage;
  const reportCode = "OverdueOView";

  const navigate = useNavigate();
  //-----------------

  const loadData = () => {
    if (sortBy.key !== "") {
      const FilterId = selectedFilter.length > 0 ? selectedFilter[0].id : null;
      if (itemSelectedFilter.length == 0) {
        setClearFilter(true);
      }
      setGlobalSpinner(true);
      equipmentGroupActions.getEquipmentList2(
        reportCode,
        sortBy.order,
        selectedAnlageG,
        parseInt(currentPage),
        parseInt(pageSize),
        sortBy.key,
        FilterId,
        itemSelectedFilter,
      );

      GridColumn_SettingActions.getSaveFilterList(selectedAnlageG, reportCode);
    }
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setOpenSearchBox(false);
  };

  const openSearchBoxEvent = (e) => {
    e.preventDefault();
    setOpenSearchBox(true);
    setDisabledSavedFilter(true);
  };

  const closeMsg = () => {
    setOpenSearchBox(false);
    setMessageBoxOpen(false);
    setDisabledSavedFilter(false);
  };

  // fetch data start ---
  const fetchData = useCallback(() => {
    if (selectedAnlageG !== null && selectedAnlageG !== undefined) {
      setGlobalSpinner(true);
      loadData();
    }
  }, [currentPage, pageSize, selectedAnlageG, searchQuery, sortBy]);
  // fetch data end ----------

  const ExportEvent = (exportOption) => {
    setGlobalSpinner(true);
    const FilterId = selectedFilter.length > 0 ? selectedFilter[0].id : null;
    equipmentGroupActions.getExportDaten(
      selectedAnlageG,
      exportOption,
      itemSelectedFilter,
      reportCode,
      FilterId,
    );
    setMessageBoxOpen(false);
  };

  const ExportadMitBilderEvent = () => {
    ExportEvent("with");
  };

  const ExportOhneBilderEvent = () => {
    ExportEvent("none");
  };

  const downloadEvent = (event) => {
    event.preventDefault();

    setMessageBoxText({
      title: localization.exportTitle,
      msg: localization.exportMsg + "\r\n" + localization.exportMsgNb,
      anlageID: 0,
    });

    setMsgButtons([
      { title: localization.cancelbutton, func: closeMsg },
      { title: localization.exportWithimg, func: ExportadMitBilderEvent },
      { title: localization.exportWithoutImg, func: ExportOhneBilderEvent },
    ]);
    setMessageBoxOpen(true);
  };

  //manage the sort function
  const requestSort = (key) => {
    UpdateSortBy(key);
  };

  const handleRowClicked = (row) => {
    sessionStorage.setItem("eqId", row.id);
    sessionStorage.setItem("invnr", row.inventarnr);
    const path = equipmentClick(row, fonctionid, fonctionsname);
    navigate(path);
  };

  useEffect(() => {
    isMountedRef.current = true;

    if (isMountedRef.current && selectedFuncId == 6) {
      fetchData();
    }

    return () => (isMountedRef.current = false);
  }, [fetchData]);

  useEffect(() => {
    function updateData() {
      var _details = equipmentGroupStore.getEquipmentOverDueListGrid();

      setData(_details);
      closeMsg();

      updateSelectedConfig("");

      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_GRID_OVERDUE_EQUIPMENTLIST_SUCCESS,
      updateData,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_GRID_OVERDUE_EQUIPMENTLIST_SUCCESS,
        updateData,
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      setData(null);
      setResponseStatus(localization.LoadFailure);
      setGlobalSpinner(false);
      updateSelectedConfig("");
    }

    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_GRID_OVERDUE_EQUIPMENTLIST_FAILURE,
      updateData,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_GRID_OVERDUE_EQUIPMENTLIST_FAILURE,
        updateData,
      );
    };
  }, []);

  useEffect(() => {
    function updatData() {
      var tmp = equipmentGroupStore.getOverDueExport();
      setExportData(tmp);
      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.EXPORT_OVERDUE_SUCCESS,
      updatData,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.EXPORT_OVERDUE_SUCCESS,
        updatData,
      );
    };
  }, []);

  useEffect(() => {
    function updatData() {
      var tmp = equipmentGroupStore.getOverDueExport();
      toast.error(tmp);
      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.EXPORT_OVERDUE_FAILURE,
      updatData,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.EXPORT_OVERDUE_FAILURE,
        updatData,
      );
    };
  }, []);

  useEffect(() => {
    if (exportData !== null && exportData !== undefined) {
      const url = window.URL.createObjectURL(exportData);

      let a = document.createElement("a");

      a.hidden = "";
      a.href = url;
      a.download = localization.overdueExam + ".xlsx"; //'Export.xlsx';
      a.click();
      setGlobalSpinner(false);
    }

    return () => {};
  }, [exportData]);

  //reload page after some change
  useEffect(() => {
    if (refresh === 1) {
      setGlobalSpinner(true);
      loadData();
    }

    return () => {
      setRefresh(0);
    };
  }, [refresh]);

  useEffect(() => {
    let _renderMe = null;
    if (data !== null && data !== undefined) {
      let headerName = [];
      let _header = data.headers;
      let _rows = data.rows;
      let _idPos;
      let _action = data.actions;
      _header.map((item) => {
        headerName.push(item.name);
      });
      headerName.map((item, index) => {
        if (item === "ID") {
          _idPos = index;
        }
      });
      setGridAction({
        actionName: _action,
        functionHandler: handleFunctionCall,
      });
      const _page = data.pagingInfo;
      const _last = (_page.currentPage - 1) * _page.pageSize + data.rows.length;
      const _first = (_page.currentPage - 1) * _page.pageSize + 1;

      setColumns(data.filters);
      set_orginalResponse({
        data: _rows,
        headerName: headerName,
        headers: _header,
        sortBy: sortBy,
        _idPos: _idPos,
      });
      setTableData({
        data: _rows,
        headerName: headerName, //body.results,
        headers: _header,
        sortBy: sortBy,
      });
      setpaginatorData({
        pageCount: data.pagingInfo.pageCount,
        lastRowOnPage: _last,
        firstRowOnPage: _first,
        rowCount: data.pagingInfo.rowCount,
        pageSize: data.pagingInfo.pageSize,
        func1: UpdateCurrentPage,
        func2: UpdatePageSize,
        activePage: data.pagingInfo.currentPage,
        rowLength: data.rows.length,
      });
      setShowSearchDialog(false);
    } else {
      setShowSearchDialog(true);
    }
    setRenderMe(_renderMe);
    return () => {};
  }, [data]);

  useEffect(() => {
    const _renderTable = (
      <GridTable
        data={tableData}
        handleAction={handleAction}
        requestSort={requestSort}
      />
    );
    setRenderTable(_renderTable);
  }, [tableData]);

  useEffect(() => {
    function getSaveFilterResultSuccess() {
      var res = gridColSettingStore.getsaveFilterListoverDueResult();
      if (res.length > 0) {
        setDropValueToHeader(res);
      } else {
        setDropValueToHeader([]);
      }
    }

    function SaveFilterResultFailure() {}

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_LIST_OVERDUE_SUCCESS,
      getSaveFilterResultSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_LIST_OVERDUE_FAILURE,
      SaveFilterResultFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_LIST_OVERDUE_SUCCESS,
        getSaveFilterResultSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_LIST_OVERDUE_FAILURE,
        SaveFilterResultFailure,
      );
    };
  }, []);

  useEffect(() => {
    let _tbody = null;
    if (renderMe !== null && renderMe !== undefined) {
      _tbody = renderMe;
    } else {
      _tbody = (
        <tr key="spinner-0">
          <td colSpan="7">
            {" "}
            <div role="status" style={{ textAlign: "center" }}>
              {localization.isLoading}
            </div>
          </td>
        </tr>
      );
    }

    setTBody(_tbody);
  }, [renderMe]);

  useEffect(() => {
    let _classname = null;
    let _renderSaveMsg = null;

    if (responseStatus !== null && responseStatus !== undefined) {
      _classname = "container alert alert-danger ext-small text-center";
      _renderSaveMsg = (
        <div className={_classname}>
          <p className="lead">{responseStatus}</p>
        </div>
      );
    }

    const interval = setInterval(() => {
      setRenderResponseMsg(null);
      setResponseStatus(null);
    }, 3000);

    setRenderResponseMsg(_renderSaveMsg);
    return () => {
      clearInterval(interval);
    };
  }, [responseStatus]);

  useEffect(() => {
    function getColSettingSaveSuccess() {
      var res = gridColSettingStore.getsaveGridSettingOverDueResult();
      if (res) {
        setShowFilterMenu(false);
        toast.success(localization.saveSuccessMsg);
        setClearFilter(true);
        setDropValueToHeader([]);
        updateSelectedFilter("");
        UpdateSortBy("InventarNr");
        setOpenSearchBox(false);
        setDisabledSavedFilter(false);
      }
    }

    function getColSettingSaveFailure() {
      var res = gridColSettingStore.getsaveGridSettingOverDueResult();
      setShowFilterMenu(false);
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_SETTING_OVERDUE_SUCCESS,
      getColSettingSaveSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_SETTING_OVERDUE_FAILURE,
      getColSettingSaveFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_SETTING_OVERDUE_SUCCESS,
        getColSettingSaveSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_SETTING_OVERDUE_FAILURE,
        getColSettingSaveFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getFilterSaveSuccess() {
      var res = gridColSettingStore.getSavedFilterOverDueResult();
      if (res) {
        setShowFilterMenu(false);
        setOpenSearchBox(false);
        setDisabledSavedFilter(false);
        toast.success(localization.filterSave);
        updateSelectedFilter([res]);
        GridColumn_SettingActions.getSaveFilterList(
          res.equipmentGroupId,
          reportCode,
        );
        setDropValueToHeader([]);
      }
    }

    function getFilterSaveFailure() {
      var res = gridColSettingStore.getSavedFilterOverDueResult();
      setShowFilterMenu(false);
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_FILTER_OVERDUE_SUCCESS,
      getFilterSaveSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_FILTER_OVERDUE_FAILURE,
      getFilterSaveFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_FILTER_OVERDUE_SUCCESS,
        getFilterSaveSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_FILTER_OVERDUE_FAILURE,
        getFilterSaveFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getEquipListSaveFilterSuccess() {
      var res = gridColSettingStore.getOverDueEquListOnFilterResult();
      if (res) {
        setData(res);
      }
      setGlobalSpinner(false);
    }

    function getEquipListSaveFilterFailure() {
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_EQUI_LIST_ON_OVERDUE_SUCCESS,
      getEquipListSaveFilterSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_EQUI_LIST_ON_OVERDUE_FAILURE,
      getEquipListSaveFilterFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_EQUI_LIST_ON_OVERDUE_SUCCESS,
        getEquipListSaveFilterSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_EQUI_LIST_ON_OVERDUE_FAILURE,
        getEquipListSaveFilterFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getDelSaveFilterResultSuccess() {
      updateSelectedFilter("");
      updateListSelectedFilter([]);
      toast.success(localization.delSuccess);
      if (currentPageRef.current != 1) {
        UpdateCurrentPage(1);
      } else {
        UpdateSortBy("InventarNr");
      }
      setGlobalSpinner(false);
    }

    function getDelSaveFilterResultFailure() {
      const res = gridColSettingStore.getsaveFilOverDueDelResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.DEL_SAVED_FILTER_OVERDUE_SUCCESS,
      getDelSaveFilterResultSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.DEL_SAVED_FILTER_OVERDUE_FAILURE,
      getDelSaveFilterResultFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.DEL_SAVED_FILTER_OVERDUE_SUCCESS,
        getDelSaveFilterResultSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.DEL_SAVED_FILTER_OVERDUE_FAILURE,
        getDelSaveFilterResultFailure,
      );
    };
  }, []);

  /**-----------------------------------------listner filter value on FilterID Start---------------------------------------*/
  useEffect(() => {
    function getSaveFilterValueSuccess() {
      var res = gridColSettingStore.getSavedFilterValueOverDueOverResult();
      if (res.length > 0) {
        updateListSelectedFilter(res);
      } else {
        updateListSelectedFilter([]);
        setGlobalSpinner(false);
      }
    }

    function getSaveFilterValueFailure() {
      setGlobalSpinner(false);
      updateListSelectedFilter([]);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_VALUE_OVERDUE_OVER__SUCCESS,
      getSaveFilterValueSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_VALUE_OVERDUE_OVER_FAILURE,
      getSaveFilterValueFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_VALUE_OVERDUE_OVER__SUCCESS,
        getSaveFilterValueSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_VALUE_OVERDUE_OVER_FAILURE,
        getSaveFilterValueFailure,
      );
    };
  }, []);

  /**-----------------------------------------listner filter value on FilterID End---------------------------------------*/
  function handleAction(actioName, rowselected, headerNameList) {
    const _row = rowselected;
    let id,
      inventarnr,
      eqBez = "";
    headerNameList.map((item, index) => {
      if (item.name.toLowerCase() === "id") {
        id = parseInt(_row[index].value);
      }
      if (item.name.toLowerCase() === "inventarnr") {
        inventarnr = _row[index].value;
      }
      if (item.name.toLowerCase() === "bezeichnung") {
        eqBez = _row[index].value;
      }
    });
    const row = { id: id, inventarnr: inventarnr, bezeichnung: eqBez };
    handleRowClicked(row);
  }
  function handleFilterLocal(filterResult) {
    setTableData({
      data: filterResult,
      headerName: _orginalResponse.headerName, //body.results,
      headers: _orginalResponse.headers,
      sortBy: sortBy,
    });
  }
  function handleDropDownSelChange(item) {
    if (item !== "") {
      GridColumn_SettingActions.getSaveFilterValue(item, reportCode);
    }

    if (currentPage !== 1) {
      UpdateCurrentPage(1);
    } else {
      UpdateSortBy("InventarNr");
    }
  }

  function deleteSaveFilter(filterId) {
    setGlobalSpinner(true);

    GridColumn_SettingActions.deleteSavedFilter(filterId, reportCode);
  }

  function getEquipmentBasedFilter(filterList) {
    setGlobalSpinner(true);
    const FilterId = null;
    if (filterList.length > 0) {
      if (currentPage === 1) {
        equipmentGroupActions.getEquipmentList2(
          reportCode,
          sortBy.order,
          selectedAnlageG,
          parseInt(1),
          parseInt(pageSize),
          sortBy.key,
          FilterId,
          filterList,
        );
      } else {
        UpdateCurrentPage(1);
      }
    } else {
      updateSelectedFilter("");
      handleDropDownSelChange("");
    }
  }

  function handleCloseFilterModal() {
    setShowFilterMenu(false);
  }

  function handleFilterMenu() {
    setGlobalSpinner(true);
    setShowFilterMenu(true);
  }

  function handleFunctionCall(e, functionName) {
    switch (functionName) {
      case "DataConfiguration":
        handleFilterMenu();
        break;
      case "ExcelExport":
        downloadEvent(e);
        break;
    }
  }

  function resetClearFilter() {
    setClearFilter(false);
  }

  return (
    <div className="container-fluid" id="content">
      <div>
        <h3 className="page-header">
          {sessionStorage.getItem("plant") + " " + " / "}
          <NavLink
            className={({ isActive }) => (isActive ? "active" : "")}
            to={"/equipmentGrpEqiupment"}
            onClick={() => {
              UpdateSortBy(null);
              UpdateSearchQuery(null);
            }}
          >
            {sessionStorage.getItem("eqBez")}
          </NavLink>
          {" " + " / " + "  " + fonctionsname}{" "}
        </h3>

        <div className="row">
          <div className="col-5"></div>
          <div className="col-4">{renderResponseMsg}</div>
        </div>
      </div>

      <div className="container-fluid">
        <SearchBox_new
          cols={columns}
          isOpen={openSearchBox}
          close={closeMsg}
          Reset={resetFilter}
          clearFilter={clearfilter}
          // selectedSaveFilter={selectedSaveFilter}
          getEquipmentBasedFilter={getEquipmentBasedFilter}
          resetClearFilter={resetClearFilter}
          ReportId={reportCode}
        />
        <HeaderBar
          headerBarControl={headerBarControl}
          paginationStates={openSearchBoxEvent}
          paginatorData={paginatorData}
          dropValueToHeader={dropValueToHeader}
          tablefunctions={tablefunctions}
          _orginalResponse={_orginalResponse}
          handleFilterLocal={handleFilterLocal}
          disabledSavedFilter={disabledSavedFilter}
          gridAction={gridAction}
          handleDropDownSelChange={handleDropDownSelChange}
          deleteSaveFilter={deleteSaveFilter}
          showSearchDialog={showSearchDialog}
          resetClearFilter={resetClearFilter}
        />
        <div className="table-responsive px-3 table-height">
          {renderTable}
          <MessageBox
            isOpen={messageBoxOpen}
            text={messageBoxText}
            functions={msgButtons}
            close={closeMsg}
          />
        </div>
        {headerBarControl.isPaginator && (
          <Paginator
            pageCount={paginatorData.pageCount}
            activePage={paginatorData.activePage}
            setCurrentPage={paginatorData.func1}
            rowCount={paginatorData.rowCount}
            pageSize={paginatorData.pageSize}
            setPageSize={paginatorData.func2}
            firstRowOnPage={paginatorData.firstRowOnPage}
            lastRowOnPage={paginatorData.lastRowOnPage}
          />
        )}
        {showFilterMenu && (
          <GridColumnSettingControl
            handleCloseModel={handleCloseFilterModal}
            pageId={reportCode}
          />
        )}
      </div>
    </div>
  );
};
export default UeberfaelligeAuftraege;
